export class ProtocolFacade {
    constructor(sdk) { this.sdk = sdk; }
    async versionUpgradeState() {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getProtocolVersionUpgradeState();
    }
    async versionUpgradeStateWithProof() {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getProtocolVersionUpgradeStateWithProofInfo();
    }
    async versionUpgradeVoteStatus(startProTxHash, count) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getProtocolVersionUpgradeVoteStatus(startProTxHash, count);
    }
    async versionUpgradeVoteStatusWithProof(startProTxHash, count) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getProtocolVersionUpgradeVoteStatusWithProofInfo(startProTxHash, count);
    }
}
